export default __webpack_public_path__ + "static/media/page3.74b7edcf.png";